<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-chart-line"></i> Relatórios - Follow-Up</h3>
      </div>
    </div>
    <Tables ref="tableGrid"
            :columns="columns"
            :showSearch="true"
            :showReload="false"
            :showTipFooter="false"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <template slot="table-header-buttons">
        <a href="javascript:void(0);" v-b-tooltip.hover :title="'Exportar'" @click="onExportExcel">
          <i class="fas fa-file-excel text-third" style="font-size: 15px"></i>
        </a>
      </template>
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <template>
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.protocolo ? obj.protocolo : 'NÃO POSSUI'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.documento ? onFormatDocument(obj.documento) : '-'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.nome ? obj.nome : 'NÃO POSSUI'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.nomePa ? obj.nomePa : '-'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.nomeGerente ? obj.nomeGerente : '-'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.agenteRelacionamento ? obj.agenteRelacionamento : '-'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.quadro ? obj.quadro : 'NÃO POSSUI'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.coluna ? obj.coluna : 'NÃO POSSUI'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.usuariosResponsaveis ? (obj.usuariosResponsaveis + (obj.gruposResponsaveis ? ';' + obj.gruposResponsaveis : '')) : (obj.gruposResponsaveis ? obj.gruposResponsaveis : 'NÃO POSSUI')"  />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.tipoEvento ? obj.tipoEvento : 'NÃO POSSUI'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.evento ? obj.evento : 'NÃO POSSUI'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.dataOcorrencia ? formatDateAndTime(obj.dataOcorrencia) : 'NÃO POSSUI'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.autorFup ? obj.autorFup : 'NÃO POSSUI'" />
          <TableColumn v-on:Edit="openCard(obj.cardId)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.descricao ? onLimitCarac(obj.descricao) : 'NÃO POSSUI'" />
          </template>
      </tr>
    </Tables>

    <SidebarSearch @search="onSearch" />
    <ModalCard
      ref="ModalCard"
      v-if="selectedCard"
      :boardColumns="[]"
      @hideModal="closeCard"
      :key="selectedCard"
      :cardId="selectedCard"
      @reloadBoardColumns="reloadGrid"
    />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading } from '@/shared/utils/UIHelper'
import ReportFollowUpRepository from '@/shared/http/repositories/crm/reportFollowUp.js'

import { NxDataGrid, NxDataGridColumn, NxDataGridItem } from '@/components/nexum/components'
import SidebarSearch from '@/views/private/reports/followup/search/SidebarRelatorioFollowUp.vue'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'

export default {
  name: 'ReportFollowUp',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      form: null,
      filters: {
        'document': null,
        'nome': null,
        'numeroPA': null,
        'nomeRegional': null,
        'gerenteId': null,
        'responsavelId': null,
        'gruposResponsaveisId': null,
        'origensId': null,
        'quadrosId': null,
        'produtosId': null,
        'valorInicio': null,
        'valorFinal': null,
        'situacao': null,
        'dataInicial': null,
        'dataFinal': null
      },
      columns: [],
      columnsOpt: [
        'PROTOCOLO',
        'CPF/CNPJ',
        'NOME',
        'PA',
        'GERENTE SISBR',
        'AGENTE RELACIONAMENTO',
        'QUADRO',
        'COLUNA',
        'RESPONSÁVEIS',
        'TIPO EVENTO',
        'EVENTO',
        'DATA DA OCORRÊNCIA',
        'AUTOR',
        'DESCRIÇÃO FOLLOW-UP'
      ],
      selectedCard: null
    }
  },
  components: {
    NxDataGrid,
    NxDataGridColumn,
    NxDataGridItem,
    SidebarSearch,
    ModalCard
  },
  methods: {
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onLoad () {
      this.setColumns()
      if (this.filters) {
        this.onLoadAll()
      } else {
        this.filters = {
          'document': null,
          'nome': null,
          'numeroPA': null,
          'nomeRegional': null,
          'gerenteId': null,
          'responsavelId': null,
          'gruposResponsaveisId': null,
          'origensId': null,
          'quadrosId': null,
          'produtosId': null,
          'valorInicio': null,
          'valorFinal': null,
          'situacao': null,
          'dataInicial': null,
          'dataFinal': null
        }
        this.onLoadAll()
      }
    },
    load (params) {
      return ReportFollowUpRepository.GetAll(this.filters, {
        params
      })
    },
    onLoadAll () {
      loading.push()
      ReportFollowUpRepository.GetAllCardsReport(this.filters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(this.onEqualsProtocols(response))
        })
        .catch(this.onException)
    },
    onExportExcel () {
      loading.push()
      ReportFollowUpRepository.ExportAllCardsReport(this.filters)
        .then((response) => {
          loading.close()
          const fileStartName = this.moment().format('YYYYMMDDhhmm')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileStartName + 'RelatorioFollowUp.xlsx'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(this.onException)
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    },
    setColumns () {
      this.columns = []
      for (let i = 0; i < this.columnsOpt.length; i++) {
        this.columns.push(this.columnsOpt[i])
      }
    },
    openCard (cardId) {
      this.selectedCard = cardId
    },
    closeCard () {
      this.selectedCard = null
    },
    reloadGrid () {
      this.onLoad()
    },
    formatDateAndTime (rawDate) {
      const date = new Date(rawDate)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${day}/${month}/${year} às ${hours}:${minutes}`
    },
    onEqualsProtocols (response) {
      let newResponse = []

      for (let index = 0; index < response.data.content.length; index++) {
        const currentItem = response.data.content[index]
        const previousItem = index > 0 ? response.data.content[index - 1] : null

        if (previousItem && currentItem.protocolo === previousItem.protocolo) {
          newResponse.push({
            protocolo: '-',
            documento: '',
            nome: '-',
            quadro: '-',
            coluna: '-',
            tipoEvento: currentItem.tipoEvento || '',
            evento: currentItem.evento || '',
            descricao: currentItem.descricao || '',
            autorFup: currentItem.autorFup || '',
            usuariosResponsaveis: currentItem.usuariosResponsaveis || '',
            gruposResponsaveis: currentItem.gruposResponsaveis || '',
            cardId: currentItem.cardId
          })
        } else {
          newResponse.push(currentItem)
        }
      }
      response.data.content = newResponse
      return response
    },
    onLimitCarac (text) {
      return text.length > 100 ? text.substring(0, 100).concat('...') : text
    }
  }
}
</script>
<style>
.popover-header {
  background-color: #04a791;
  color: #eceff1
}
</style>



// WEBPACK FOOTER //
// src/views/private/reports/followup/ReportFollowUp.vue